"use client";

import { useEffect } from 'react';

/**
 * Progressive Enhancement Component
 * Adds the js-loaded class after hydration to enable animations
 * without causing hydration mismatches
 */
export function ProgressiveEnhancement() {
  useEffect(() => {
    // Instant enterprise-grade animation trigger
    document.documentElement.classList.add('js-loaded');
    
    // Cleanup function
    return () => {
      document.documentElement.classList.remove('js-loaded');
    };
  }, []);

  // This component renders nothing - it's purely for side effects
  return null;
}
